// extracted by mini-css-extract-plugin
export default {"normalImage":"MediaItems_normalImage__njRTw","zoomedImage":"MediaItems_zoomedImage__SjsGk"};